import i18next from 'i18next';

i18next.addResources('en', 'Records', {
  newPeriod: 'Record new period',
  newMash: 'Record new mash',
  newAdmin: 'Create new admin'
});
